exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trainer-info[data-v-2f87555c]{position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}", ""]);

// exports
